type PetWeightLike = {
  measured_at?: string | null;
  created_at?: string | null;
  deleted_at?: string | null;
};

const resolveWeightTimestamp = (weight: PetWeightLike): number => {
  const candidate = weight.measured_at ?? weight.created_at ?? null;
  if (!candidate) return 0;
  const parsed = new Date(candidate).getTime();
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const sortPetWeightsDesc = <T extends PetWeightLike>(weights: T[]): T[] => {
  return [...weights].sort((a, b) => resolveWeightTimestamp(b) - resolveWeightTimestamp(a));
};

export const getActivePetWeights = <T extends PetWeightLike>(weights: T[]): T[] => {
  return weights.filter((w) => !w.deleted_at);
};

export const getLatestPetWeight = <T extends PetWeightLike>(weights: T[]): T | null => {
  const active = getActivePetWeights(weights);
  if (active.length === 0) return null;
  return sortPetWeightsDesc(active)[0] ?? null;
};

